import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { ContactCard } from "./contact-card/contact-card";
import { SupportDocuments } from "./support-documents/support-documents";
import * as contacts from "../../../../../../../public/pia/contact/contact.json";
import * as supportDocumentsData from "../../../../../../../public/pia/contact/download/documents.json";
import { ProductDetailBreadcrumb } from "../breadcrumb/breadcrumb";

@Component({
  selector: "claas-contacts",
  imports: [
    ProductDetailBreadcrumb,
    TranslatePipe,
    ContactCard,
    SupportDocuments,
  ],
  templateUrl: "./contacts.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./contacts.scss",
})
export class Contacts {
  contacts = contacts;
  supportDocumentsData: {
    id: string;
    name: string;
    language: string;
    format: string;
    size: string;
    path: string;
  }[] = supportDocumentsData.tableData;
}
